import { EducationRoute } from '@/modules/education/v1/api/EducationRoute'
import { EnumRouteType } from '@/contracts/core/api/enum/EnumRouteType'
import { ApiResponse } from '@/contracts/core/api/entity/ApiResponse'
import { Settings } from '@/modules/education/v1/api/v1/settings/Dto/Settings'

/** PUT /api/education/v1/settings: период 300…86400, размер 1…100; иначе validation_failed */
export class ChangeSettingsRoute extends EducationRoute<Settings, Settings> {
  type(): EnumRouteType {
    return EnumRouteType.PUT
  }

  url(): string {
    return '/api/education/v1/settings'
  }

  offline(params: Settings): Promise<ApiResponse<Settings>> {
    return Promise.resolve(new ApiResponse({ success: true, data: new Settings(params) }))
  }
}
